import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';
import { FontIcon } from 'material-ui';

export default class Dropdown extends Component {
  static propTypes = {
    labelProperty: PropTypes.string,
    valueProperty: PropTypes.string,
    list: PropTypes.array
  };

  static defaultProps = {
    labelProperty: 'label',
    valueProperty: 'value',
    list: []
  };

  constructor() {
    super(...arguments);
    this.state = {
      listVisible: false,
      placeHolder: true,
      selected: {}
    };
    this.props.list.map(item => {
      if (this.props.value === item[this.props.valueProperty]) {
        this.state.selected = item;
        this.state.placeHolder = false;
      }
    });
  }

  select(item) {
    this.setState({ placeHolder: !item });
    item = item || {};
    this.setState({ selected: item });
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  }

  componentDidMount() {
    this.clickListener = this.hide.bind(this);
    document.addEventListener('mousedown', this.clickListener);
    document.addEventListener('touchstart', this.clickListener);
    if (super.componentDidMount) {
      super.componentDidMount();
    }
  }

  getValue() {
    if (this.state.selected) {
      return this.state.selected[this.props.valueProperty];
    } else {
      return null;
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.clickListener);
    document.removeEventListener('touchstart', this.clickListener);

    if (super.componentWillUnmount) {
      super.componentWillUnmount();
    }
  }

  show(event) {
    this.setState({ listVisible: true });
    event.stopPropagation();
  }

  hide(e) {
    this.setState({ listVisible: false });
  }

  render() {
    let listItems,
      classes = ClassNames('cio-dropdown', {
        shown: this.state.listVisible,
        'has-placeholder': this.state.placeHolder
      });
    listItems = this.props.list.map(item => {
      let value = this.state.selected[this.props.valueProperty];
      if (item[this.props.valueProperty] !== value) {
        return (
          <div
            key={item[this.props.valueProperty]}
            onTouchTap={this.select.bind(this, item)}
          >
            {item[this.props.labelProperty]}
          </div>
        );
      }
    });
    return (
      <div className={classes}>
        <div
          className={'cio-dropdown-display'}
          onTouchTap={this.show.bind(this)}
        >
          <span>
            {this.state.selected[this.props.labelProperty] ||
              this.props.placeholder}
          </span>
          <FontIcon className="md md-expand-more" />
        </div>
        <div className="cio-dropdown-list">{listItems}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/Dropdown.js